export const ChartCurrentSelectionMeta = {
    scenarios: {
    },

    testids: {
        date: "",
    }
};